import { ChevronLeft } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div className="custom-tabs">
      <div className="d-flex align-items-center border-bottom">
        <button
          type="button"
          className="back-button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ChevronLeft className="rounded-circle" />
        </button>

        <div className={`fw-semibold ${data.length > 24 ? "h4" : "h3"} my-4 `}>
          {data}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
